
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.47 6.47a.75.75 0 011.06 0l3.438 3.437a.75.75 0 11-1.06 1.06L12.75 8.812V18a.75.75 0 01-1.5 0V8.81l-2.157 2.158a.75.75 0 11-1.06-1.06L11.47 6.47z"}})])
          )
        }
      }
    